import React, { useCallback } from "react";
import { observer } from "mobx-react-lite";

import "./VideoProgressBar.scss";
import VideoSlider from "./components/VideoSlider";
import useTheme from "../../../../services/theme-service/ThemeService";
import { videoPlayerService } from "../../../../services/video-player/VideoPlayerService";
import { VideoAnalysisService } from "../../../../services/inspection/VideoAnalysisService";
import { Segmentation } from "../../../../api-models/response/VideoAnalysisDataResponse";

export default observer(function VideoProgressBar({
  videoAnalysis,
  filteredSegmentations,
}: {
  videoAnalysis?: VideoAnalysisService;
  filteredSegmentations?: Segmentation[];
}) {
  const { themeClass } = useTheme();
  const { videoLoadedSeconds, videoProgress, setVideoProgress, jumpTo, videoDuration } =
    videoPlayerService;

  const updatePlayerState = useCallback(
    (time: number) => {
      setVideoProgress(time);
      jumpTo(time);
    },
    [jumpTo, setVideoProgress]
  );

  return (
    <div className={themeClass(["video-progress-bar"])}>
      <VideoSlider
        videoDuration={videoDuration}
        currentTime={videoProgress}
        onChange={updatePlayerState}
        bufferedTime={videoLoadedSeconds}
        videoAnalysis={videoAnalysis}
        filteredSegmentations={filteredSegmentations}
      />
    </div>
  );
});
